export class PopupBlockedError extends Error { }

class SelfClosingWindow extends Window {
    public lastSearch: string
}

export async function openWindowAndWaitForItToBeClosed(url: string): Promise<URLSearchParams | null> {
    const newWindow = (window.open(url, "_blank") as SelfClosingWindow);

    if (!newWindow) {
        throw new PopupBlockedError();
    }

    try {
        while (!newWindow.closed) {
            await new Promise(resolve => setTimeout(resolve, 500));
        }
    } catch {
        return null;
    }

    let lastSearch: string | null = null;
    try {
        lastSearch = newWindow.lastSearch || null;
    } catch {
        // Popup closed on another origin (e.g. Microsoft login); same-origin policy
        // blocks reading window.lastSearch (SecurityError). Treat as flow interrupted.
        return null;
    }

    if (!lastSearch) {
        return null;
    }

    return new URLSearchParams(lastSearch);
}
